export default "__VITE_ASSET__BgJtHf0R__"